import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators, NgModel, NgModelGroup } from '@angular/forms';
import { ErrorData } from '@delon/form';
import { IComponentDef } from '../../shared';
import { RWidgetFormRenderBase } from '../common-component/r-widget-form-render-base';
import { RStringComponent } from '../widget-render/r-string/r-string.component';
import { RWidgetFormService } from './r-widget-form.service';
// import { FormProperty, PropertyGroup } from './model/form.property';
import { Directive } from '@angular/core';
@Component({
  selector: 'r-widget-form',
  templateUrl: './r-widget-form.component.html',
  host: {
    '[class.r-widget-form]': 'true'
  }
})
export class RWidgetFormComponent extends RWidgetFormRenderBase implements OnDestroy {
  inputs = [];

  @ViewChild('validateForm', { static: false }) validateForm: NgForm;

  /** 页面表单 */
  rootProperty;
  rootComponent: IComponentDef;
  /** JSON */
  @Input() previewJson: string;
  /** 表单提交 */
  @Output() submitForm: EventEmitter<any> = new EventEmitter();
  /** 表单重置 */
  @Output() resetForm: EventEmitter<any> = new EventEmitter();
  /** 表单默认值 */
  @Input() formData;
  /** 是否显示默认按钮 */
  @Input() showButton = true;
  /** disabled */
  @Input() disabled;

  formId = 'formId' + Math.random().toString(36).substr(3, 16) + new Date().getTime();

  /** 订阅组件服务 */
  inputsSubscribe;
  constructor(
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private _rWidgetFormService: RWidgetFormService,
    private zone: NgZone
  ) {
    super();
    this.inputsSubscribe = this._rWidgetFormService.inputsSubject.subscribe(res => {
      let _this = this;
      let input = res;
      /**
       * 注册formControl 以及 默认值赋值
       */
      if (input && input.ngModel && this.validateForm) {
        if (input.data.formId === this.formId) {
          this.inputs.push(input.ngModel);
          this.validateForm.addControl(input.ngModel);
        }
      }
      /**
       * disabled状态添加
       */
      setTimeout(() => {
        console.log(this.validateForm.form, this.formId, 'inputsSubscribe');

        if (_this.validateForm && _this.validateForm.form) {
          _this.validateForm.form.patchValue(_this.formData);
          if (_this.disabled) {
            input.config.disabled = true;
          } else {
            input.config.disabled = false;
          }
        }
      }, 100);
    });
  }

  ngOnInit(): void {}
  ngAfterViewInit() {
    console.log(this.formData, 'formData');
    this.importJsonFun();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.previewJson) {
      this.importJsonFun();
    }
  }

  /** 导入原始json面板 */
  importJsonFun() {
    this.inputs.map(dir => {
      this.validateForm.removeControl(dir);
    });
    this.rootComponent = null;
    try {
      const component = JSON.parse(this.previewJson);
      if (component) {
        this.setFormId([component]);
        this.rootComponent = JSON.parse(JSON.stringify(component, null, '\t'));
      }
    } catch {}
  }
  setFormId(list) {
    if (list.length) {
      list.map(item => {
        item.formId = this.formId;
        if (item.children.length) {
          this.setFormId(item.children);
        }
      });
    }
  }
  _submitForm() {
    for (const key in this.validateForm.form.controls) {
      this.validateForm.form.controls[key].markAsDirty();
      this.validateForm.form.controls[key].updateValueAndValidity();
    }
    if (this.validateForm.valid) {
      this.submitForm.emit(this.validateForm.form.value);
    }
  }
  _resetForm() {
    this.validateForm.resetForm();
    this.resetForm.emit();
  }

  /**
   * 组件销毁时解除订阅，重置form
   */
  ngOnDestroy(): void {
    this.rootComponent = null;
    this.inputs.map(dir => {
      this.validateForm.removeControl(dir);
    });
    this.inputs = [];
    this.inputsSubscribe.unsubscribe();
  }
}
